module.exports = __webpack_public_path__ + "a1867f2395682bc6abc74a1a8c3d6563.pdf";